<template>
    <div>
        <b-overlay :show="show_overlay" variant="success" :opacity=".5" rounded="sm" style="min-height:100vh;">
            <GardenHelpEditQuoteForm v-if="!show_quote_details" :job_id="job_id" :perosnal_data_type="perosnal_data_type"
                :first_name="first_name" :last_name="last_name" :email="email" :phone_number="phone_number"
                :contact_through="contact_through" :services_list="services_list" :job_services="job_services"
                :quote_services="quote_services" :quote_items="quote_items" :show_products="true"
                :currency="currency_code" />

            <GardenHelpQuoteDetails v-else class="mt-3" :quote_table_items="quote_table_items"
                :contractor_name="contractor_name" :issue_date="issue_date" :booking_date="booking_date"
                :job_type="job_type" :quote_number="quote_number" :customer_name="customer_name"
                :quote_status="quote_status" :subtotal="subtotal" :vat="vat" :vat_number="vat_no" :total="total"
                :currency_code="currency_code" :currency_icon="currency_icon" :company_logo="company_logo" 
                :company_reg_no="company_reg_no"/>

            <b-row class="justify-content-center justify-content-lg-right mt-3 mx-0" v-if="!show_quote_details">
                <b-col xl="3" lg="4" md="6" class=" text-center">
                    <b-button type="button" variant="garden-help-info-outline"
                        class="btn-bumblebee btn-garden-help mb-1 w-100" @click="clickCancelEditQuote">Back</b-button>
                </b-col>
                <b-col xl="3" lg="4" md="6" class=" text-center">
                    <b-button type="button" variant="garden-help-primary" class="btn-bumblebee btn-garden-help mb-1 w-100"
                        @click="clickReviewQuoteDetails">Review Quote Details</b-button>
                </b-col>
            </b-row>

            <b-row class="justify-content-center justify-content-lg-right mt-3 mx-0 " v-else>
                <b-col xl="3" lg="4" md="6" class=" text-center">
                    <b-button type="button" variant="garden-help-info-outline"
                        class="btn-bumblebee btn-garden-help mb-1 w-100" @click="clickCancelQuote">Back</b-button>
                </b-col>
                <b-col xl="3" lg="4" md="6" class=" text-center">
                    <b-button v-if="!is_loading_save_send" type="button" variant="garden-help-primary" class="btn-bumblebee btn-garden-help mb-1 w-100"
                        @click="clickEditQuote">Save and Send Quote</b-button>
                    <b-button v-else-if="is_loading_save_send" type="button" disabled variant="garden-help-primary"
                        class="btn-bumblebee btn-garden-help mb-1 w-100">
                        <b-spinner small label="Small Spinner" variant="light"></b-spinner>
                        Loading
                    </b-button>
                </b-col>
            </b-row>
        </b-overlay>
    </div>
</template>

<script>
import { listServicesRequest } from "@/utils/helper-functions-garden-help.js"
import GardenHelpEditQuoteForm from "./EditQuoteForm.vue";
import GardenHelpQuoteDetails from "./QuoteDetails.vue"
import countries_list from '@/assets/country-list-data.json'

import axios from "axios";

export default {
    name: "GardenHelpEditQuoteIndex",
    components: {
        GardenHelpEditQuoteForm,
        GardenHelpQuoteDetails
    },
    data() {
        return {
            client_name: "GARDENHELP",
            show_overlay: true,

            quote_id: null,
            quote_data: {
                "status": "",
                "subtotal": 0,
                "vat": 0,
                "total": 0,
                "currency": this.currency_code,
                "model_type": "Job",
                "model_id": null,
                "client": "GARDENHELP",
                "invoice_items": []
            },
            quote_job: null,
            user_id: null,
            user_type: null,
            vat_no: null,

            action: 'view',
            base_url: null,


            // view quote details
            quote_table_items: [],
            contractor_name: null,
            vat_number: null,
            issue_date: null, //new Date(),
            booking_date: null,
            job_type: null,
            quote_number: null,
            customer_name: null,
            quote_status: null,

            subtotal: null,
            vat: null,
            total: null,
            vat_no: null,


            job_id: null,
            job_obj: null,
            //customer data
            perosnal_data_type: "view",
            first_name: "",
            last_name: "",
            email: "",
            phone_number: "",
            contact_through: null,
            // services
            services_list: [],
            job_services: [],
            quote_services: [{
                service_id: null,
                service_name: null,
                invalid_service: false,
                estimated_price: null,
                invalid_estimated_price: false,
                description: null,
            }],
            // items/products
            quote_items: [{
                name: null,
                invalid_name: false,
                description: null,
                quantity: 1,
                invalid_quantity: false,
                price: null,
                invalid_price: false
            }],

            show_quote_details: false,


            country: null,
            currency_code: null,
            currency_icon: null,

            company_logo: null,
            company_reg_no: null,

            is_loading_save_send: false

        };
    },
    beforeMount() {
        this.show_overlay = true
    },
    async mounted() {
        this.quote_id = Number(this.$route.params.id);
        this.user_type = localStorage.getItem('user_type')
        let user = JSON.parse(window.localStorage.getItem("user"));
        this.user_id = user.id

        this.country = user.country
        // console.log(user.country)
        const country_data = countries_list.find(({ country }) => country === user.country);
        // console.log(country_data)
        this.currency_code = country_data.currency_code
        this.currency_icon = country_data.currency_icon

        this.base_url = this.$route.path

        this.show_overlay = true

        this.services_list = await this.listServicesRequest(this.user)
        // console.log(this.services_list)

        // this.show_overlay = true
        this.getQuoteDetails()

        if (this.user_type == 'operator') {
            this.getContractorData()
        }



    },
    watch: {
        quote_items(newval, oldVal) {
            console.log(newval)
            console.log(oldVal)
        }
    },
    methods: {
        listServicesRequest,
        getQuoteDetails() {
            console.log("----------------------------------------")
            console.log("in get quote details")
            // this.show_overlay = true
            axios
                .get("/payment/invoices/" + this.quote_id, {
                    headers: {
                        Accept: "application/json",
                        "Content-Type": "application/json",
                        client: this.client_name,
                        Authorization:
                            "Bearer " +
                            JSON.parse(window.localStorage.getItem("user")).access_token,
                    },
                })
                .then((response) => {
                    // console.log(response)

                    console.log("in get quote details -- response")
                    console.log(response.data)
                    this.quote_data = response.data
                    this.quote_job = response.data.model

                    this.vat_no = response.data.owner.vat_number
                    this.company_reg_no =response.data.owner.company_reg_no

                    this.quote_services = []
                    this.quote_items = []

                    this.quote_table_items = this.quote_data.items

                    this.contractor_name = this.quote_data.owner.name
                    this.issue_date = this.quote_data.created_at
                    this.quote_number = this.quote_data.invoice_number
                    this.quote_status = this.quote_data.status
                    this.subtotal = this.quote_data.subtotal
                    this.vat = this.quote_data.vat
                    this.total = this.quote_data.total

                    //     this.quote_services.push({
                    //         service_id: service.id,
                    //         service_name: service.name,
                    //         invalid_service: false,
                    //         estimated_price: null,
                    //         invalid_estimated_price: false,
                    //         description: null,
                    //     })

                    console.log("quote_table_items")
                    console.log(this.quote_table_items)
                    let temp = this
                    setTimeout(() => {
                        for (let i = 0; i < temp.quote_table_items.length; i++) {
                            let quote_item = temp.quote_table_items[i]
                            // console.log(quote_item.type == "service")
                            if (quote_item.type === "service") {
                                temp.quote_services.push({
                                    service_name: quote_item.name,
                                    invalid_service: false,
                                    estimated_price: quote_item.price,
                                    invalid_estimated_price: false,
                                    description: quote_item.description
                                })

                            } else if (quote_item.type === 'item') {
                                temp.quote_items.push({
                                    name: quote_item.name,
                                    invalid_name: false,
                                    description: quote_item.description,
                                    quantity: quote_item.quantity,
                                    invalid_quantity: false,
                                    price: quote_item.price_per_item,
                                    invalid_price: false
                                })
                            }
                        }
                        console.log("quote_services")
                        console.log(temp.quote_services)
                        console.log("quote_items")
                        console.log(temp.quote_items)

                        if (temp.quote_items.length == 0) {
                            temp.quote_items.push({
                                name: null,
                                invalid_name: false,
                                description: null,
                                quantity: 1,
                                invalid_quantity: false,
                                price: null,
                                invalid_price: false
                            })
                        }

                        // temp.getJobDetails(response.data.model.id)


                        temp.booking_date = temp.quote_job.details.booking_date_web
                        temp.job_type = temp.quote_job.property.type
                        temp.customer_name = temp.quote_job.contact.name

                        // temp.quote_services = []
                        // set personal data
                        temp.first_name = temp.quote_job.contact.first_name
                        temp.last_name = temp.quote_job.contact.last_name
                        temp.phone_number = temp.quote_job.contact.phone
                        temp.email = temp.quote_job.contact.email
                        // temp.contact_through = temp.quote_job.contact.contact_through
                        console.log("temp.quote_job.services")
                        console.log(temp.quote_job.services)
                        // set services data
                        temp.job_services = temp.quote_job.services.filter(((item) => item.type == 'service'))
                        console.log("job_services")
                        console.log(temp.job_services)

                        // if (temp.quote_job.orig_services.length > temp.quote_job.services.length) {
                        //     for (let i = temp.quote_job.services.length; i < temp.quote_job.orig_services.length; i++) {
                        //         let service = temp.quote_job.orig_services[i]
                        //         temp.quote_services.push({
                        //             service_id: service.id,
                        //             service_name: service.name,
                        //             invalid_service: false,
                        //             estimated_price: null,
                        //             invalid_estimated_price: false,
                        //             description: null,
                        //         })
                        //     }
                        // }

                        // for (let i = 0; i < temp.job_services.length; i++) {
                        //     let service = temp.job_services[i]
                        //     temp.quote_services.push({
                        //         service_id: service.id,
                        //         service_name: service.name,
                        //         invalid_service: false,
                        //         estimated_price: null,
                        //         invalid_estimated_price: false,
                        //         description: null,
                        //     })
                        // }

                        temp.show_overlay = false


                    }, 1500)

                });
        },
        getJobDetails(id) {
            console.log("----------------------------------------")
            console.log("in get job details")
            axios
                .get("/jobs/jobs/" + id, {
                    headers: {
                        Accept: "application/json",
                        "Content-Type": "application/json",
                        client: this.client_name,
                        Authorization:
                            "Bearer " +
                            JSON.parse(window.localStorage.getItem("user")).access_token,
                    },
                })
                .then((response) => {
                    console.log("in get job details -- reponse")
                    console.log(response)
                    // console.log(response.data)

                });
        },

        getContractorData() {
            console.log("in get contractor data", this.user_type, this.user_id)
            this.show_overlay = true

            axios
                .get("/operator/contractor/profile", {
                    headers: {
                        Accept: "application/json",
                        "Content-Type": "application/json",
                        client: this.client_name,
                        Authorization:
                            "Bearer " +
                            JSON.parse(window.localStorage.getItem("user")).access_token,
                    },
                })
                .then((response) => {
                    console.log(response)
                    this.vat_no = response.data.vat_no
                    this.company_reg_no =response.data.company_reg_no
                    this.company_logo = response.data.logo


                });
        },


        clickCancelEditQuote() {
            this.$router.go(-1);

        },
        clickReviewQuoteDetails() {
            console.log("----------------------------------------")
            console.log("in click review quote details")

            let is_valid_services = this.checkQuoteServicesValidation(),
                is_valid_items = this.checkQuoteItemsValidation()

            if (is_valid_services && is_valid_items) {

                this.subtotal = 0
                this.quote_table_items = []

                console.log("--------------------------")
                console.log("job_services")
                console.log(this.job_services)
                console.log("quote_services")
                console.log(this.quote_services)
                console.log("services_list")
                console.log(this.services_list)

                for (let i = 0; i < this.job_services.length; i++) {

                    let item = this.quote_services[i]
                    console.log("iii job_services -- ", item)
                    let selected_service = this.services_list.find(element => element.name === item.service_name)
                    console.log("sssss selected_service", selected_service)
                    this.quote_table_items.push({
                        type: "service",
                        item_id: selected_service.id,
                        name: item.service_name,
                        price_str: this.currency_icon + item.estimated_price,
                        price: item.estimated_price,
                        description: item.description
                    })

                    this.subtotal += Number(item.estimated_price)
                }
                for (let i = this.job_services.length; i < this.quote_services.length; i++) {
                    let selected_service = this.services_list.find(element => element.id == this.quote_services[i].service_id)
                    console.log("selected_service   -- ", i, selected_service)
                    this.quote_services[i].service_name = selected_service.name

                    let item = this.quote_services[i]
                    this.quote_table_items.push({
                        type: "service",
                        item_id: this.quote_services[i].service_id,
                        name: selected_service.name,
                        price_str: this.currency_icon + item.estimated_price,
                        price: item.estimated_price,
                        description: item.description
                    })

                    this.subtotal += Number(item.estimated_price)
                }

                if (this.quote_items.length >= 1 && this.quote_items[0].name != null && this.quote_items[0].name != '') {
                    for (let j = 0; j < this.quote_items.length; j++) {

                        let item = this.quote_items[j],
                            items_price = item.quantity * item.price

                        this.quote_table_items.push({
                            type: "item",
                            item_id: null,
                            name: item.name,
                            quantity: item.quantity,
                            price_str: this.currency_icon + items_price,
                            price: items_price,
                            price_per_item: item.price,
                            description: item.description
                        })

                        this.subtotal += Number(items_price)
                    }
                }


                this.vat = this.vat_no != null ? (this.subtotal * 0.135).toFixed(3) : 0 // Update the vat from 23% to 13.5% upon Ed request 12/8/2024
                this.total = (Number(this.subtotal) + Number(this.vat)).toFixed(3)

                console.log("quote_table_items")
                console.log(this.quote_table_items)

                this.show_quote_details = !this.show_quote_details
            }
        },
        checkQuoteServicesValidation() {
            let is_valid_services = true
            for (let i = this.job_services.length; i < this.quote_services.length; i++) {
                let quote_service = this.quote_services[i]
                console.log(quote_service)
                if (quote_service.service_id == null || quote_service.service_id == '') {
                    this.quote_services[i].invalid_service = true
                    is_valid_services = false
                } else {
                    this.quote_services[i].invalid_service = false
                }

                if (quote_service.estimated_price == null || quote_service.estimated_price == '') {
                    this.quote_services[i].invalid_estimated_price = true
                    is_valid_services = false
                } else {
                    this.quote_services[i].invalid_estimated_price = false
                }
            }
            return is_valid_services;
        },
        checkQuoteItemsValidation() {
            console.log("check item validation")
            let is_valid_items = true
            for (let i = 0; i < this.quote_items.length; i++) {
                let quote_item = this.quote_items[i]
                // console.log(quote_item)
                // console.log(quote_item.price, quote_item.price == null, quote_item.price == '')
                // console.log(quote_item.name, quote_item.name == null, quote_item.name == '')

                if ((quote_item.name != null && quote_item.name != '') ||
                    (quote_item.price != null && quote_item.price != '') ||
                    (quote_item.quantity != null && quote_item.quantity != '' && quote_item.quantity != 1) ||
                    (quote_item.description != null && quote_item.description != '')) {

                    if (quote_item.name == null || quote_item.name == '') {
                        this.quote_items[i].invalid_name = true
                        is_valid_items = false
                    } else {
                        this.quote_items[i].invalid_name = false
                    }

                    if (quote_item.quantity == null || quote_item.quantity == '') {
                        this.quote_items[i].invalid_quantity = true
                        is_valid_items = false
                    } else {
                        this.quote_items[i].invalid_quantity = false
                    }

                    if (quote_item.price == null || quote_item.price == '') {
                        this.quote_items[i].invalid_price = true
                        is_valid_items = false
                    } else {
                        this.quote_items[i].invalid_price = false
                    }
                }
                if (quote_item.quantity === 1) {
                    this.invalid_quantity = false
                }
            }
            return is_valid_items;
        },


        clickCancelQuote() {
            this.show_quote_details = !this.show_quote_details

        },
        clickEditQuote() {
            console.log("click save and send quote")
            console.log("job id", this.job_id)
            console.log("subtotal", this.subtotal)
            console.log("vat", this.vat)
            console.log("total", this.total)
            console.log(this.quote_table_items)
            console.log(this.quote_id, this.quote_id == null, isNaN(this.quote_id))

            this.is_loading_save_send  = true

            let requestData = {
                client: this.client_name,
                "subtotal": this.subtotal,
                "vat": Number(this.vat),
                "total": this.total,
                "currency": this.currency_code,
                "invoice_items": this.quote_table_items
            }

            console.log(requestData)

            let params = ''
            console.log("request quote", this.quote_id)
            params = '/' + this.quote_id
            requestData.id = this.quote_id
            requestData._method = 'put'

            console.log(requestData)
            console.log(params)

            axios
                .post("payment/invoices" + params, requestData, {
                    headers: {
                        Accept: "application/json",
                        "Content-Type": "application/json",
                        client: this.client_name,
                        Authorization:
                            "Bearer " +
                            JSON.parse(window.localStorage.getItem("user")).access_token,
                    },
                })
                .then((response) => {
                    console.log(response);
                    this.$fire({
                        // title: "Title",
                        text: "Quote is updated successfully ",
                        type: "success",
                        customClass: {
                            container: "swal-alert-garden-help",
                            confirmButton:
                                "btn btn-bumblebee btn-garden-help btn-garden-help-primary btn-garden-help-submit",
                            cancelButton:
                                "btn btn-bumblebee btn-garden-help btn-garden-help-danger-outline btn-garden-help-submit",
                        },
                        // timer: 3000,
                    }).then((r) => {
                        // console.log(r.value);
                        this.is_loading_save_send = false;
                        // this.$router.go();
                        this.$router.push({ name: "GardenHelpMyJobs", query: { type: 'quotes' } });
                    });
                })
                .catch((error) => {
                    console.log(error.response);
                    this.is_loading_save_send = false;
                    this.$fire({
                        // title: "Title",
                        text: error.response.data.error
                            ? error.response.data.error
                            : error.response.data.message,
                        type: "error",
                        customClass: {
                            container: "swal-alert-garden-help",
                            confirmButton:
                                "btn btn-bumblebee btn-garden-help btn-garden-help-primary btn-garden-help-submit",
                            cancelButton:
                                "btn btn-bumblebee btn-garden-help btn-garden-help-danger-outline btn-garden-help-submit",
                        },
                        // timer: 3000,
                    }).then((r) => {
                        // console.log(r.value);
                    });
                });

        }
    }
};
</script>


// WEBPACK FOOTER //
// src/projects/garden_help/quotes/EditQuoteIndex.vue